import accessAuth from "./AuthControl"
import accessDashboard from "./DashboardControl"
import accessMaster from "./MasterControl"
import accessUsers from "./UsersControl"
import accessSettings from "./SettingsControl"
import accessPremises from "./PremisesControl"
import accessReport from "./ReportControl"
import accessCommunication from "./CommunicationControl"
import accessVisitor from "./VisitorControl"
import accessHelpDesk from "./HelpDeskControl"
import accessNotifications from "./NotificationsControl"
import accessFinance from "./FinanceControl"
import accessMaintenance from "./MaintenanceControl"
import accessAmenities from "./AmenitiesControl"
import accessDocuments from "./DocumentsControl"

const RoutesMap = {
    ...accessAuth,
    ...accessDashboard,
    ...accessMaster,
    ...accessSettings,
    ...accessUsers,
    ...accessPremises,
    ...accessReport,
    ...accessCommunication,
    ...accessVisitor,
    ...accessHelpDesk,
    ...accessNotifications,
    ...accessFinance,
    ...accessMaintenance,
    ...accessAmenities,
    ...accessDocuments,
}

export default RoutesMap;